import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { StickyCTA, ScrollToTop } from './components/UI';

import { Home } from './pages/Home';
import { Concrete } from './pages/Concrete';
import { HeatedFloor } from './pages/HeatedFloor';
import { Formwork } from './pages/Formwork';
import { Services } from './pages/Services';
import { Realizations } from './pages/Realizations';
import { Contact } from './pages/Contact';
import { Sitemap } from './pages/Sitemap';
import { NotFound } from './pages/NotFound';

const App: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen font-sans text-slate-800 selection:bg-brand-red selection:text-white">
      <ScrollToTop />
      <Header />
      <main className="flex-grow pt-20"> {/* Added padding-top for fixed header */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/beton" element={<Concrete />} />
          <Route path="/plancher-radiant" element={<HeatedFloor />} />
          <Route path="/coffrage-et-fondation" element={<Formwork />} />
          <Route path="/services" element={<Services />} />
          <Route path="/realisations" element={<Realizations />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/plan-du-site" element={<Sitemap />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
      <StickyCTA />
    </div>
  );
};

export default App;